<template>
  <v-dialog
    v-model="isShow"
    hide-overlay
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        Загрузка
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalLoading',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
